import React, { memo } from 'react';
import { Route as RRoute, RouteProps, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {getIsAuthorized} from "@reducers/auth";

interface Props extends RouteProps {
  authorize?: boolean;
}

function Route({ authorize = false, children, ...others }: Props) {
  const isAuthorized = useSelector(getIsAuthorized);
  const { pathname } = useLocation();
  
  if (authorize && !isAuthorized) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: pathname },
        }}
      />
    );
  }
  // return <RRoute {...others}>{children}</RRoute>;
  return <RRoute {...others}/>
}

export default memo(Route);

